<template>
  <div dir="rtl">
    <b-alert
      v-if="error"
      variant="danger"
      show
    >
      {{ error }}
    </b-alert>
    <div v-if="loading">
      <center><b-spinner
        small
        type="grow"
      /> جاري تحميل بيانات الطلب...</center>
    </div>
    <b-card
      v-if="!loading && requestDetails"
      class="shadow-sm p-2"
    >
    <b-tabs>
      <b-tab title="تفاصيل الطلب الخارجي">
        <center v-if="requestDetails.success == false">
        <h4 class="text-danger">
          {{ requestDetails.message }}
        </h4>
      </center>
      <div v-else>
        <!-- Grouped pluck tables side by side -->
        <div class="section-row mb-3">
          <!-- <section v-for="section in mainSections" :key="section.title" class="side-section">
            <h6 class="mb-2 font-weight-bold">{{ section.title }}</h6>
            <b-table
              :items="section.rows"
              :fields="['label', 'value']"
              small
              bordered
              responsive
              head-variant="light"
              class="section-table"
            >
              <template #cell(label)="d">
                <span class="font-weight-bold">{{ d.item.label }}</span>
              </template>
            </b-table>
          </section> -->
          <section class="side-section">
            <h6 class="mb-2 font-weight-bold">
              {{ mainSections[0].title }}
            </h6>
            <b-table
              :items="mainSections[0].rows"
              :fields="['label', 'value']"
              small
              bordered
              responsive
              head-variant="light"
              class="section-table"
            >
              <template #cell(label)="d">
                <span class="font-weight-bold">{{ d.item.label }}</span>
              </template>
            </b-table>
            <div
              v-if="assignedCustomers.length"
              class="mt-2"
            >
              <h6 class="mb-2 font-weight-bold">
                العملاء المرتبطون
              </h6>
              <b-table
                :items="assignedCustomers"
                :fields="customerFields"
                small
                bordered
                responsive
                head-variant="light"
                class="section-table"
              >
                <template #cell(actions)="data">
                  <b-button
                    v-if="hasPermission('assign-customers external_requests')"
                    variant="outline-danger"
                    size="sm"
                    :disabled="unassigningCustomerId === data.item.id"
                    title="إلغاء الربط"
                    @click="confirmUnassignCustomer(data.item)"
                  >
                    <b-spinner
                      v-if="unassigningCustomerId === data.item.id"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="UserMinusIcon"
                      size="14"
                    />
                  </b-button>
                </template>
              </b-table>
            </div>
            <b-button
              v-if="hasPermission('assign-customers external_requests')"
              variant="primary"
              size="sm"
              class="mt-2"
              @click="showAssignCustomerModal = true"
            >
              ربط مواطن بالطلب
            </b-button>
          </section>
          <section class="side-section">
            <h6 class="mb-2 font-weight-bold">
              {{ mainSections[1].title }}
            </h6>
            <b-table
              :items="mainSections[1].rows"
              :fields="['label', 'value']"
              small
              bordered
              responsive
              head-variant="light"
              class="section-table"
            >
              <template #cell(label)="d">
                <span class="font-weight-bold">{{ d.item.label }}</span>
              </template>
            </b-table>
          </section>
          <section class="side-section">
            <h6 class="mb-2 font-weight-bold">
              {{ mainSections[2].title }}
            </h6>
            <b-table
              :items="mainSections[2].rows"
              :fields="['label', 'value']"
              small
              bordered
              responsive
              head-variant="light"
              class="section-table"
            >
              <template #cell(label)="d">
                <span class="font-weight-bold">{{ d.item.label }}</span>
              </template>
            </b-table>
          </section>
          <section>
            <h6 class="mb-2 font-weight-bold">
              بيانات مالية
            </h6>
            <b-table
              :items="requestDetails.external_financials"
              :fields="financialFields"
              small
              bordered
              responsive
              class="coords-table"
              head-variant="light"
            />
          </section>

        </div>
        <b-row>
          <b-col
            md="6"
            sm="12"
          >
            <h6 class="mb-2 font-weight-bold">
              الإحداثيات
            </h6>
            <b-table
              :items="coordinatesTable"
              :fields="coordsFields"
              small
              bordered
              responsive
              class="coords-table"
              head-variant="light"
            >
              <template #cell(latitude)="data">
                <code>{{ data.item.latitude }}</code>
              </template>
              <template #cell(longitude)="data">
                <code>{{ data.item.longitude }}</code>
              </template>
              <template #cell(dms_latitude)="data">
                <code>{{ data.item.dms_latitude }}</code>
              </template>
              <template #cell(dms_longitude)="data">
                <code>{{ data.item.dms_longitude }}</code>
              </template>
              <template #cell(coordinate_system)="data">
                <code>{{ data.item.coordinate_system }}</code>
              </template>
            </b-table>
            <b-button
              v-if="coordinatesTable.length > 0"
              variant="primary"
              @click="holdAsGisCoordinates"
              title="ربط علي المكتب الفني"
            >
              <feather-icon icon="MapPinIcon" />
            </b-button>
          </b-col>
          <b-col
            md="6"
            sm="12"
          >
            <coordinates-map
              v-if="requestDetails.external_coordinates && requestDetails.external_coordinates.length > 2 "
              :coordinates="Array.isArray(requestDetails.external_coordinates) ? requestDetails.external_coordinates : (requestDetails.external_coordinates ? [requestDetails.external_coordinates] : [])"
            />
          </b-col>
        </b-row>
      </div>
      </b-tab>
      <b-tab title="اخطار المواطن" v-if="hasPermission('Agricultural reform accountant')" lazy>
        <citizen-notification 
          v-if="requestDetails.success !== false"
          :request-details="requestDetails"
          class="mb-4"
        />
      </b-tab>
      <b-tab title="المرفقات" lazy>
        <attachments-144
          v-if="requestDetails.success !== false"
          :external-request-id="requestDetails.id"
        />
      </b-tab>
    </b-tabs>
    
    </b-card>

    <b-modal
      v-model="showAssignCustomerModal"
      title="ربط مواطن بالطلب"
      no-close-on-backdrop
      centered
      @hidden="resetAssignCustomerForm"
    >
      <validation-observer ref="assignCustomerForm">
        <b-form @submit.prevent>
          <validation-provider
            #default="{ errors }"
            name="الاسم"
            vid="name"
            rules="required"
          >
            <b-form-group
              label="الاسم *"
              label-for="assign-customer-name"
            >
              <b-form-input
                id="assign-customer-name"
                v-model="assignCustomerForm.name"
                placeholder="الاسم الكامل"
              />
              <small
                v-if="errors[0]"
                class="text-danger"
              >{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="{ errors }"
            name="الرقم القومي"
            vid="national_id"
            rules="required|national_id"
          >
            <b-form-group
              label="الرقم القومي *"
              label-for="assign-customer-national-id"
            >
              <b-form-input
                id="assign-customer-national-id"
                v-model="assignCustomerForm.national_id"
                placeholder="الرقم القومي"
                maxlength="14"
              />
              <small
                v-if="errors[0]"
                class="text-danger"
              >{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <b-form-group
            label="رقم الهاتف"
            label-for="assign-customer-phone"
          >
            <b-form-input
              id="assign-customer-phone"
              v-model="assignCustomerForm.phone"
              placeholder="رقم الهاتف"
            />
          </b-form-group>
        </b-form>
      </validation-observer>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="secondary"
          @click="cancel"
        >
          إلغاء
        </b-button>
        <b-button
          variant="primary"
          :disabled="assigningCustomer"
          @click="submitAssignCustomer"
        >
          <b-spinner
            v-if="assigningCustomer"
            small
            class="mr-50"
          />
          ربط
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import externalRequestsApi from '@/api/external-requests/externalRequests'
import {
  BCard, BTable, BSpinner, BAlert, BRow, BCol, BTabs, BTab, BBadge, BButton,
  BModal, BForm, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, national_id } from '@validations'
import CoordinatesMap from '@/views/modules/projects/CoordinatesMap.vue'
import CitizenNotification from '@/views/modules/external-requests/CitizenNotification.vue'
import Attachments144      from '@/views/modules/external-requests/Attachments144.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: {
    BCard, BTable, BSpinner, BAlert, CoordinatesMap, BRow, BCol, CitizenNotification, Attachments144, BTabs, BTab, BBadge, BButton,
    BModal, BForm, BFormGroup, BFormInput, ValidationProvider, ValidationObserver,
  },
  props: {
    externalRequestCode: null,
  },
  data() {
    return {
      requestDetails: null,
      loading: true,
      error: null,
      showAssignCustomerModal: false,
      assigningCustomer: false,
      unassigningCustomerId: null,
      assignCustomerForm: {
        name: '',
        national_id: '',
        phone: '',
      },
      customerFields: [
        { key: 'name', label: 'الاسم' },
        { key: 'national_id', label: 'الرقم القومي' },
        { key: 'phone', label: 'رقم الهاتف' },
        { key: 'actions', label: 'إجراءات', thClass: 'text-center', tdClass: 'text-center' },
      ],
      financialFields: [
        { key: 'document_number', label: 'رقم المستند', sortable: true },
        { key: 'document_date', label: 'تاريخ المستند', sortable: true },
        { key: 'amount', label: 'المبلغ', sortable: true },
        { key: 'doc_from', label: 'اسم البنك', sortable: true },
        { key: 'fee_type', label: 'نوع الرسوم', sortable: true },
        { key: 'branch_name', label: 'اسم الفرع', sortable: true },
        { key: 'is_paid', label: 'الدفع', sortable: true },
        { key: 'phone_number', label: 'الهاتف', sortable: true },
        { key: 'name', label: 'الاسم', sortable: true },
        { key: 'Sheikha', label: 'الشياخة', sortable: true },
      ],
    }
  },
  computed: {
    assignedCustomers() {
      const customers = this.requestDetails?.customers
      return Array.isArray(customers) ? customers : []
    },
    criminalReports() {
      const reports = this.requestDetails?.external_criminal_reports
      return Array.isArray(reports) ? reports : []
    },
    hasCriminalReport() {
      return this.criminalReports.length > 0
    },
    mainSections() {
      if (!this.requestDetails) return []
      const r = this.requestDetails
      return [
        {
          title: 'بيانات المواطن',
          rows: [
            { label: 'رقم الطلب', value: r.request_number },
            { label: 'الاسم', value: r.name },
            { label: 'الرقم القومي', value: r.national_number },
            { label: 'رقم الهاتف', value: r.phone_number },
          ],
        },
        {
          title: 'بيانات الطلب',
          rows: [
            { label: 'المعاينة', value: r.inspection },
            { label: 'موقف الإحداثيات', value: r.coordinates_status },
            { label: 'موقف التصالح', value: r.legalization_status },
            { label: 'المساحة', value: `${r.area || ''} ${r.unit || ''}` },
            { label: 'النشاط', value: r.activity },
            { label: 'جهة الولاية الاصلية', value: r.state_side?.name },
            { label: 'رد المساحة العسكرية', value: r.military_area_return },
            { label: 'الجهة المتابعة', value: r.handling_authority },
            { label: 'نوع التعاقد', value: r.contract_type },
            { label: 'الحالة', value: r.contract_status },
            { label: 'موقف الإزالة/الإسترداد', value: r.stop_removal_recovery },
            { label: 'مرفقات التعاقد', value: r.contract_attachments },
            { label: 'سبب لن يتم التعاقد', value: r.reason_no_contract },

          ],
        },
        // {
        //   title: "بيانات مالية قبل التعاقد",
        //   rows: (r.external_financials && r.external_financials.length > 0)
        //     ? [
        //         { label: "اسم البنك", value: r.external_financials[0].doc_from },
        //         { label: "رقم المستند", value: r.external_financials[0].document_number },
        //         { label: "مبلغ السداد", value: r.external_financials[0].amount },
        //         { label: "تاريخ المستند", value: r.external_financials[0].document_date },
        //         { label: "اسم الفرع", value: r.external_financials[0].branch_name },
        //         { label: "الدفع", value: r.external_financials[0].paid  },
        //         { label: "المبلغ", value: r.external_financials[0].amount  },
        //         { label: "نوع الرسوم", value: r.external_financials[0].fee_type  },
        //         { label: "الشياخة", value: r.external_financials[0].Sheikha  },
        //         { label: "المحافظة/المركز", value: r.external_financials[0].gov_center  },
        //       ]
        //     : []
        // },

        {
          title: 'بيانات القطعة',
          rows: [
            { label: 'الغربى', value: r.western },
            { label: 'الشرقى', value: r.eastern },
            { label: 'الجنوبى', value: r.southern },
            { label: 'الشمالى', value: r.northern },
            { label: 'المكان', value: r.place },
          ],
        },

      ]
    },
    coordinatesTable() {
      return this.requestDetails?.external_coordinates || []
    },

    coordsFields() {
      const coords = this.coordinatesTable
      if (!coords.length) return []
      const allPossible = [
        { key: 'latitude', label: 'خط العرض' },
        { key: 'longitude', label: 'خط الطول' },
        { key: 'utm_east', label: 'UTM شرق' },
        { key: 'utm_north', label: 'UTM شمال' },
        { key: 'dms_latitude', label: 'النظام الستيني - عرض' },
        { key: 'dms_longitude', label: 'النظام الستيني - طول' },
      ]
      // Only include fields where at least one row has a non-empty, non-null value
      return allPossible.filter(field => coords.some(row => row[field.key] !== undefined
          && row[field.key] !== null
          && String(row[field.key]).trim() !== ''))
    },

  },
  methods: {
    resetAssignCustomerForm() {
      this.assignCustomerForm = {
        name: '',
        national_id: '',
        phone: '',
      }
      if (this.$refs.assignCustomerForm) {
        this.$refs.assignCustomerForm.reset()
      }
    },
    async submitAssignCustomer() {
      const valid = await this.$refs.assignCustomerForm.validate()
      if (!valid) return

      this.assigningCustomer = true
      try {
        const response = await externalRequestsApi.assignCustomer(
          this.requestDetails.id,
          this.assignCustomerForm,
        )
        const customer = response.data
        const message = response.message || 'تم ربط العميل بالطلب'

        if (customer) {
          if (!this.requestDetails.customers) {
            this.$set(this.requestDetails, 'customers', [])
          }
          const alreadyLinked = this.requestDetails.customers.some(c => c.id === customer.id)
          if (!alreadyLinked) {
            this.requestDetails.customers.push(customer)
          }
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'تم بنجاح',
            icon: 'CheckCircleIcon',
            variant: 'success',
            text: message,
          },
        })
        this.showAssignCustomerModal = false
      } catch (error) {
        const validationErrors = error.response?.data?.errors
        let message = error.response?.data?.message || error.message || 'حدث خطأ أثناء ربط العميل'
        if (validationErrors) {
          const firstError = Object.values(validationErrors).flat()[0]
          if (firstError) message = firstError
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطأ',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: message,
          },
        })
      } finally {
        this.assigningCustomer = false
      }
    },
    async confirmUnassignCustomer(customer) {
      if (!customer?.id || this.unassigningCustomerId) return

      const confirmed = await this.$bvModal.msgBoxConfirm(
        `هل تريد إلغاء ربط العميل "${customer.name || customer.national_id}" من هذا الطلب؟`,
        {
          title: 'تأكيد إلغاء الربط',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'إلغاء الربط',
          cancelTitle: 'تراجع',
          cancelVariant: 'outline-secondary',
          centered: true,
        },
      )

      if (!confirmed) return
      await this.unassignCustomer(customer)
    },
    async unassignCustomer(customer) {
      if (!customer?.id || !this.requestDetails?.id) return

      this.unassigningCustomerId = customer.id
      try {
        const response = await externalRequestsApi.unassignCustomer(
          this.requestDetails.id,
          customer.id,
        )
        const message = response.message || 'تم إلغاء ربط العميل من الطلب'

        if (Array.isArray(this.requestDetails.customers)) {
          this.requestDetails.customers = this.requestDetails.customers.filter(
            c => c.id !== customer.id,
          )
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'تم بنجاح',
            icon: 'CheckCircleIcon',
            variant: 'success',
            text: message,
          },
        })
      } catch (error) {
        const message = error.response?.data?.message
          || error.message
          || 'حدث خطأ أثناء إلغاء ربط العميل'
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطأ',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: message,
          },
        })
      } finally {
        this.unassigningCustomerId = null
      }
    },
    holdAsGisCoordinates() {
      externalRequestsApi.holdAsGisCoordinates(this.requestDetails.id)
        .then(response => {
          const message = (response && response.message)
            || (response && response.data && typeof response.data === 'string' ? response.data : null)
            // || (response && response.data && response.data.message)
            || 'تم ربط الإحداثيات على المكتب الفني بنجاح'
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'تم بنجاح',
              icon: 'CheckCircleIcon',
              variant: 'success',
              text: message,
            },
          })
        })
        .catch(error => {
          const message = (error.response && error.response.data && error.response.data.message)
            || error.message
            || 'حدث خطأ أثناء ربط الإحداثيات'
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطأ',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: message,
            },
          })
        })
    },
    formatNationalNumber(value) {
      if (value === null || value === undefined) return ''
      return String(value)
    },
    formatCriminalValue(value, type) {
      if (value === null || value === undefined || value === '') return '—'
      if (type === 'boolean') return value ? 'نعم' : 'لا'
      return value
    },
    getCriminalReportRows(report) {
      return [
        { label: 'رقم الطلب', value: report.request_number },
        { label: 'الاسم', value: report.name },
        { label: 'الرقم القومي', value: report.national_number, isNationalNumber: true },
        { label: 'المحافظة', value: report.governorate },
        { label: 'المركز', value: report.center },
        { label: 'تتم التسعير', value: report.pricing_done, type: 'boolean' },
        { label: 'المساحة', value: report.area ? `${report.area} ${report.unit || ''}`.trim() : null },
        { label: 'المعاينة', value: report.inspection, type: 'boolean' },
        { label: 'موقف صالح / غير صالح للتقنين', value: report.legalization_status },
        { label: 'موقف التعاقد', value: report.contract_status },
        { label: 'موقف الإحداثيات', value: report.coordinates_status, type: 'boolean' },
        { label: 'سبب لن يتم التعاقد', value: report.reason_no_contract, type: 'boolean' },
        { label: 'نوع التعاقد', value: report.contract_type },
        { label: 'جهة الولاية للتعامل مع الطلب', value: report.handling_authority },
        { label: 'جهة الولاية الأصلية', value: report.original_authority },
        { label: 'وقف الإزالة / الإسترداد', value: report.stop_removal_recovery },
        { label: 'الاذون الغير محصلة', value: report.uncollected_permits },
        { label: 'رد المساحة العسكرية', value: report.military_area_return },
        { label: 'قبل / بعد القانون', value: report.before_after_law, type: 'boolean' },
        { label: 'الغربي', value: report.western },
        { label: 'الشرقي', value: report.eastern },
        { label: 'القبلي', value: report.southern },
        { label: 'البحري', value: report.northern },
        { label: 'المكان', value: report.place },
        { label: 'نوع النشاط', value: report.activity },
        { label: 'تاريخ الإنشاء', value: report.created_at },
        { label: 'تاريخ التحديث', value: report.updated_at },
      ]
    },
  },
  async created() {
    try {
      
      if (!this.externalRequestCode) {
        // need to check if route contain external-request-details/:id
        if (this.$route.path.includes('external-request-details')) {
        const { id } = this.$route.params
          const res = await externalRequestsApi.show(id)
          this.requestDetails = res.data
        }
      } else {
        const res = await externalRequestsApi.showByCode(this.externalRequestCode)
        this.requestDetails = res.data
      }
    } catch (e) {
      this.error = 'Failed to load details'
    } finally {
      this.loading = false
    }
  },
}
</script>

<style scoped>
.section-row {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
}
.side-section {
  flex: 1 1 320px;
  min-width: 280px;
  max-width: 400px;
}
.section-table td, .section-table th,
.coords-table td, .coords-table th {
  font-size: 1rem;
  vertical-align: middle;
  border: 1px solid #cfd8dc !important;
  text-align: right;
}
.section-table th {
  background-color: #e3f2fd !important;
}
.coords-table {
  margin: 0 auto;
  max-width: 800px;
}
h6 {
  border-bottom: 1.5px solid #1976d2;
  padding-bottom: 4px;
  margin-bottom: 8px;
  color: #1976d2;
  font-weight: bold;
}
@media (max-width: 950px) {
  .section-row {
    flex-direction: column;
    gap: 0.5rem;
  }
  .side-section {
    max-width: 100%;
  }
}
@media (max-width: 600px) {
  .coords-table, .section-table { font-size: .92rem; }
}
</style>
